import {
  Component,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef, ElementRef} from '@angular/core';
import {DomService} from '../../../../services/dom-service/dom.service';
import {DetailsNameValueComponent} from '../name-and-value/details-name-value.component';
import {DetailScreenComponent} from '../detail-screen/detail-screen.component';
import {DetailLabel} from '../mapping-classes/detail-label';
import {DetailScreensService} from '../services/detail-screens-service';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import * as DetailTable from '../table-lib';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {ClaimsTableComponent} from '../detail-table/claims/claims-table.component';
import {LeaseObjectsTableComponent} from '../detail-table/lease-objects/lease-objects-table.component';
import {ParticipatingAccountsTableComponent} from '../detail-table/participating-accounts/participating-accounts-table.component';
import {PhysicalCardTableComponent} from '../detail-table/debit-card/physical-card/physical-card-table.component';
import {
  RequestedPhysicalCardTableComponent,
} from '../detail-table/debit-card/requested-physical-card/requested-physical-card-table.component';
import {MobileCardTableComponent} from '../detail-table/debit-card/mobile-card/mobile-card-table.component';
import {RequestedMobileCardTableComponent} from '../detail-table/debit-card/requested-mobile-card/requested-mobile-card-table.component';
import {CreditCardTableComponent} from '../detail-table/credit-card/card/card-table.component';
import {
  RequestedCreditCardTableComponent,
} from '../detail-table/credit-card/requested-card/requested-card-table.component';
import {
  OnlineKeyTableComponent,
} from '../detail-table/online-keys/card/onlinekey-card-table.component';
import {OnlineKeySearchComponent} from '../detail-table/online-keys/search/onlinekey-search.component';
import {OnlinekeyRequestedCardTableComponent} from '../detail-table/online-keys/requestedcards/onlinekey-requested-card-table.component';
import {IdealProfileTableComponent} from '../detail-table/ideal-profile/idealprofile-card-table.component';
import {
  VolmachtGranteesTableComponent
} from "../detail-table/volmacht/volmacht-grantees/volmacht-grantees-table.component";
import {
  VolmachtGrantorsTableComponent
} from "../detail-table/volmacht/volmacht-grantors/volmacht-grantors-table.component";
import {
  VolmachtProductsTableComponent
} from "../detail-table/volmacht/volmacht-products/volmacht-products-table.component";

@Component({
  selector: 'app-details-panel',
  templateUrl: './detail-panel.component.html',
  styleUrls: ['../detail-screen/detail-screen.component.css'],
})

export class DetailPanelComponent {
  @ViewChild('field_name_and_value_pair', {read: ViewContainerRef}) nameValueContainer: ViewContainerRef;
  @ViewChild('sub_panel', {read: ViewContainerRef}) subPanelContainer: ViewContainerRef;
  @ViewChild('sub_panel2', {read: ViewContainerRef}) subPanelContainer2: ViewContainerRef;
  @ViewChild('table', {read: ViewContainerRef}) tableContainer: ViewContainerRef;
  @ViewChild('table2', {read: ViewContainerRef}) tableContainer2: ViewContainerRef;

  restrictedData: boolean;
  nameAndValues: Map<string, any>;
  subPanels: any[];
  title: string;
  expanded: boolean;
  expandable: boolean;
  lazyLoaded: boolean;
  hasTable: boolean;
  tableCreated: boolean;
  subPanelTableCreated: boolean;
  errorText: string;
  hideErrorText: boolean;
  lazyLoadingData: LazyLoadingData;
  tableInstance;
  tableComponent;
  parent: DetailScreenComponent;
  transactionsDetailsBankCode: string;

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef, private el: ElementRef,
              private detailScreenService: DetailScreensService) {
    this.subPanels = [];
    this.nameAndValues = new Map<string, any>();
    this.expanded = false;
  }

  initializeNameAndValueComponents() {
    this.changeRef.detectChanges();
    if (this.nameAndValues) {
      const tempMap = new Map();
      for (const nameAndValue of this.nameAndValues.entries()) {
        tempMap.set(nameAndValue[0], this.createDetailsViewNameAndValueComponent(nameAndValue[1]));
        this.changeRef.detectChanges();
      }
      this.nameAndValues = tempMap;
    }
  }

  initializeSubPanelComponents() {
    this.changeRef.detectChanges();
    if (this.subPanels) {
      const tempList = [];
      this.subPanels.forEach((subPanel) => {
        const subPanelComponent = this.createSubPanelComponent(subPanel);
        tempList.push(subPanelComponent);
        subPanelComponent.initializeSubPanelComponents();
        subPanelComponent.initializeNameAndValueComponents();
        this.changeRef.detectChanges();
      });
      this.subPanels = tempList;
    }
  }

  private createDetailsViewNameAndValueComponent(detailsViewNameAndValue: DetailLabel) {
    if (!this.nameValueContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(DetailsNameValueComponent, this.nameValueContainer);
    const nameValueComponent = viewRef.instance as DetailsNameValueComponent;
    nameValueComponent.restrictedData = this.restrictedData;
    nameValueComponent.name = detailsViewNameAndValue.name;
    nameValueComponent.value = detailsViewNameAndValue.value;
    nameValueComponent.type = detailsViewNameAndValue.type;
    nameValueComponent.currencyCode = detailsViewNameAndValue.currencyCode;
    nameValueComponent.transactionsDetailsBankCode = this.transactionsDetailsBankCode;
    nameValueComponent.urlLink = detailsViewNameAndValue.urlLink;
    nameValueComponent.hasLink = detailsViewNameAndValue.getHasLink();
    nameValueComponent.hasLinkToSameTab = detailsViewNameAndValue.getHasLinkToSameTab();
    return nameValueComponent;
  }

  private createSubPanelComponent(subPanel: DetailPanel) {
    if (!this.subPanelContainer) {
      return null;
    }
    let viewRef;
    if(subPanel.name === 'Gevolmachtigde') {
      viewRef = this.domService.addComponentToDOM(DetailPanelComponent, this.subPanelContainer2);
    }  else {
      viewRef = this.domService.addComponentToDOM(DetailPanelComponent, this.subPanelContainer);
    }
    const panelComponentToReturn = viewRef.instance as DetailPanelComponent;
    panelComponentToReturn.restrictedData = this.restrictedData;
    panelComponentToReturn.title = subPanel.name;
    panelComponentToReturn.errorText = subPanel.errorText;
    panelComponentToReturn.hideErrorText = (panelComponentToReturn.errorText === null || panelComponentToReturn.errorText === undefined);
    panelComponentToReturn.subPanels = subPanel.subPanels;
    panelComponentToReturn.nameAndValues = subPanel.nameAndValues;
    panelComponentToReturn.expandable = false;
    panelComponentToReturn.expanded = true;
    panelComponentToReturn.transactionsDetailsBankCode = subPanel.transactionsDetailsBankCode;

    if (subPanel.hasTable) { // Enable tables on subpanels
      panelComponentToReturn.hasTable = subPanel.hasTable || false;
      panelComponentToReturn.lazyLoadingData = subPanel.lazyLoadingData || undefined;
    }

    return panelComponentToReturn;
  }

  onClick() {
    if (this.lazyLoaded) {
      this.getTableDataAndCreateTable();
    }

    if (this.hasTable && !this.tableCreated) {
      this.createTable(this.lazyLoadingData.data);
    }

    this.checkSubPanelTables();

    this.expanded = !this.expanded;
    if (!this.expanded) {
      this.parent.allExpanded = false;
    }
    if (this.expanded) {
      this.changeRef.detectChanges();
      this.el.nativeElement.scrollIntoView({behavior: 'smooth'});
      if (this.parent.panelsAreAllExpanded()) {
        this.parent.allExpanded = true;
      }
    }
  }

  /*
    * Create tables on subpanels
    * */
  private checkSubPanelTables() {

    if (this.subPanels.length) {
      this.subPanels.forEach((panel) => {
        if (panel.hasTable && panel.hasTable !== undefined &&  !this.subPanelTableCreated) {
          this.createTable(panel.lazyLoadingData.data, panel);
        }
      });
      this.subPanelTableCreated = true;
    }
  }

  private getTableDataAndCreateTable() {
    this.detailScreenService.getTableData(this.lazyLoadingData.lazyLoadingUrl,
      this.lazyLoadingData.arrangementNumber, this.lazyLoadingData.administrationCode)
      .subscribe((response) => {
        this.createTable(response);
      });
    this.lazyLoaded = false;
  }

  expand() {
    this.expanded = true;
    this.checkSubPanelTables();
    if (this.lazyLoaded) {
      this.getTableDataAndCreateTable();
    }
    if (this.hasTable && !this.tableCreated) {
      this.createTable(this.lazyLoadingData.data);
    }
    this.changeRef.detectChanges();
  }

  private createTable(response, panel?) {

    const lazyLoadingUrl = !panel ? this.lazyLoadingData.lazyLoadingUrl : panel.lazyLoadingData.lazyLoadingUrl;
    this.tableInstance = new DetailTable[this.capitalizeFirstLetter(lazyLoadingUrl)](response);

    if (!this.tableContainer) {
      return null;
    }

    switch (lazyLoadingUrl) {
      case 'claims':
        this.tableComponent = this.createClaimsTable();
        break;
      case 'leaseobjects':
        this.tableComponent = this.createObjectsTable();
        break;
      case 'participatingaccounts':
        this.tableComponent = this.createParticipatingAccountsTable();
        break;
      case 'physical':
        this.tableComponent = this.createPhysicalCardsTable(panel);
        break;
      case 'requestedphysical':
        this.tableComponent = this.createRequestedPhysicalCardsTable(panel);
        break;
      case 'mobile':
        this.tableComponent = this.createdMobileCardsTable(panel);
        break;
      case 'requestedmobile':
        this.tableComponent = this.createRequestedMobileTable(panel);
        break;
      case 'cards':
        this.tableComponent = this.createCardsTable(panel);
        break;
      case 'requestedcards':
        this.tableComponent = this.createRequestedCardsTable(panel);
        break;
      case 'onlinekeycards':
        this.tableComponent = this.createOnlinekeyCardsTable(panel);
        break;
      case 'onlinekeyrequestedcards':
        this.tableComponent = this.createOnlinekeyRequestedCardsTable(panel);
        break;
      case 'onlinekeysearch':
        this.tableComponent = this.createOnlinekeySearchTable();
        break;
      case 'idealprofilecards':
        this.tableComponent = this.createIdealProfileTable();
        break;
      case 'volmacht':
        this.tableComponent = this.createVolmachtProductsTable();
        break;
      case 'volmachtGrantors':
        this.tableComponent = this.createVolmachtGrantorsTable();
        break;
      case 'volmachtGrantees':
        this.tableComponent = this.createVolmachtGranteesTable();
        break;
    }

    this.changeRef.detectChanges();
    this.tableCreated = true;
  }

  createClaimsTable() {
    const viewRef = this.domService.addComponentToDOM(ClaimsTableComponent, this.tableContainer);
    let tableComponentToReturn = viewRef.instance as ClaimsTableComponent;
    tableComponentToReturn = this.setBasicComponentValues(tableComponentToReturn);
    tableComponentToReturn.totalOriginalAmount = this.tableInstance.totalOriginalAmount;
    tableComponentToReturn.totalOutstandingAmount = this.tableInstance.totalOutstandingAmount;
    return tableComponentToReturn;
  }

  private createObjectsTable() {
    const viewRef = this.domService.addComponentToDOM(LeaseObjectsTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as LeaseObjectsTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createParticipatingAccountsTable() {
    const viewRef = this.domService.addComponentToDOM(ParticipatingAccountsTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as ParticipatingAccountsTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createPhysicalCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(PhysicalCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as PhysicalCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn, panel);
  }

  private createRequestedPhysicalCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(RequestedPhysicalCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as RequestedPhysicalCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createdMobileCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(MobileCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as MobileCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createRequestedMobileTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(RequestedMobileCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as RequestedMobileCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(CreditCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as CreditCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createRequestedCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(RequestedCreditCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as RequestedCreditCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }
  private createOnlinekeyCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(OnlineKeyTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as OnlineKeyTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createOnlinekeyRequestedCardsTable(panel?) {
    const tableContainer = !panel ? this.tableContainer : panel.tableContainer;
    const viewRef = this.domService.addComponentToDOM(OnlinekeyRequestedCardTableComponent, tableContainer);
    const tableComponentToReturn = viewRef.instance as OnlinekeyRequestedCardTableComponent;
    panel.tableInstance = this.tableInstance;
    panel.errorText = this.errorText;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createOnlinekeySearchTable() {
    const viewRef = this.domService.addComponentToDOM(OnlineKeySearchComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as OnlineKeySearchComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createIdealProfileTable() {
    const viewRef = this.domService.addComponentToDOM(IdealProfileTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as IdealProfileTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createVolmachtProductsTable() {
    const viewRef = this.domService.addComponentToDOM(VolmachtProductsTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as VolmachtProductsTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createVolmachtGrantorsTable() {
    const viewRef = this.domService.addComponentToDOM(VolmachtGrantorsTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as VolmachtGrantorsTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private createVolmachtGranteesTable() {
    const viewRef = this.domService.addComponentToDOM(VolmachtGranteesTableComponent, this.tableContainer2);
    const tableComponentToReturn = viewRef.instance as VolmachtGranteesTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private setBasicComponentValues(componentToReturn, panel?) {
    const componentData = !panel ? this : panel;

    componentToReturn.errorText = componentData.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = componentData.restrictedData;
    componentToReturn.tableColumns = componentData.tableInstance.rowHeaders;
    componentToReturn.tableData = componentData.tableInstance.rowData;
    if (componentToReturn.dataSource) {
      componentToReturn.dataSource.data = componentData.tableInstance.rowData;
      componentToReturn.detailScreenComponent = this.parent;
      componentToReturn.paginationObj = this.lazyLoadingData.paginationObj;
      componentToReturn.localPaginationObj.totalNumberOfCards = this.lazyLoadingData.paginationObj.totalNumberOfCards;
    }
    return componentToReturn;
  }

  private capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
